/* eslint-disable */
import Vue from 'vue'
import Router from 'vue-router'
import Uploader from '@/components/Uploader'
import Login from '@/components/Login'
import Settings from '@/components/Settings'
import Dashboard from '@/components/Dashboard'
import ResetPassword from '@/components/ResetPassword'
import Statistics from '@/components/Statistics'
import Blueprints from '@/components/Blueprints'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*', 
      redirect: '/Uploader'
    },
    {
      path: '/',
      name: 'default',
      component: Login
    },
    { 
      path: '/uploader', 
      name: 'Uploader',
      component: Uploader,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard', 
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      } 
    },
    {
      path: '/login', 
      name: 'Login',
      component: Login,
      props: (route) => ({ state: route.query.state,  client_id: route.query.client_id, response_type: route.query.response_type, scope: route.query.scope, redirect_uri: route.query.redirect_uri })
    },
    {
      path: '/settings', 
      name: 'Settings',
      component: Settings,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/reset-password',
      name: 'ResetPassword',
      component: ResetPassword
    },
    {
      path: '/jom-stats-jom',
      name: 'Statistics',
      component: Statistics,
    },
    {
      path: '/jom-blueprints-jom',
      name: 'Blueprints',
      component: Blueprints,
    }
  ]
})

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = localStorage.getItem('dataat')
  const currentUserId = localStorage.getItem('id')
  // alert('CURRENTUSER TOKEN ' + currentUser)
  // alert('CURRENTUSER ID ' + currentUserId)

  if (requiresAuth && !currentUser) {
      next('/login')
  } else if (requiresAuth && currentUser) {
      next()
  } else {
      next()
  }
})

export default router


// WEBPACK FOOTER //
// ./src/router/index.js